/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostAttestationV3Resp } from './PostAttestationV3Resp';
import {
    PostAttestationV3RespFromJSON,
    PostAttestationV3RespFromJSONTyped,
    PostAttestationV3RespToJSON,
} from './PostAttestationV3Resp';

/**
 * 
 * @export
 * @interface PostAttestationV3200ResponseAllOf
 */
export interface PostAttestationV3200ResponseAllOf {
    /**
     * 
     * @type {PostAttestationV3Resp}
     * @memberof PostAttestationV3200ResponseAllOf
     */
    result?: PostAttestationV3Resp;
}

/**
 * Check if a given object implements the PostAttestationV3200ResponseAllOf interface.
 */
export function instanceOfPostAttestationV3200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostAttestationV3200ResponseAllOfFromJSON(json: any): PostAttestationV3200ResponseAllOf {
    return PostAttestationV3200ResponseAllOfFromJSONTyped(json, false);
}

export function PostAttestationV3200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAttestationV3200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : PostAttestationV3RespFromJSON(json['result']),
    };
}

export function PostAttestationV3200ResponseAllOfToJSON(value?: PostAttestationV3200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': PostAttestationV3RespToJSON(value.result),
    };
}

